import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import createReduxWaitForMiddleware from 'redux-wait-for-action';
import rootReducer from './reducers';
import rootSaga from './sagas';
import * as actionCreators from './actions';

const bindMiddleware = middleware => {
  if (process.env.NODE_ENV === 'development') {
    const composeEnhancers = composeWithDevTools({ actionCreators, trace: true, traceLimit: 25 });
    return composeEnhancers(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

function initStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(rootReducer, initialState, bindMiddleware([sagaMiddleware, createReduxWaitForMiddleware()]));

  store.sagaTask = sagaMiddleware.run(rootSaga);

  return store;
}

export default initStore;
